import { AttachedProperty, Attribute } from '../../../concepts/objects';

export const ZoneAssocation = new AttachedProperty('zone', null);

export type ZonePeers = readonly [boolean, boolean, boolean, boolean];
export const ZonePeersAttr = new Attribute<ZonePeers>('peers', [false, true, false, false]);
